import { render, staticRenderFns } from "./CustomJson.vue?vue&type=template&id=f9940476&scoped=true&"
import script from "./CustomJson.vue?vue&type=script&lang=js&"
export * from "./CustomJson.vue?vue&type=script&lang=js&"
import style0 from "./CustomJson.vue?vue&type=style&index=0&id=f9940476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9940476",
  null
  
)

export default component.exports